import { useEffect, useState } from 'react';
// fetch
import { getOrderAuditProperties, getOrderAuditUsers } from 'src/fetch/orders';
import {
  getOrganizationAdditionalChargesAuditProperties, getOrganizationAdditionalChargesAuditUsers,
  getOrganizationAuditProperties,
  getOrganizationAuditUsers,
} from 'src/fetch/organizations';
import { getLocationAuditProperties, getLocationAuditUsers } from 'src/fetch/locations';
import { getTruck, getTruckAuditProperties, getTruckAuditUsers, getTruckPermitRuleAuditProperties, getTruckPermitRuleAuditUsers } from 'src/fetch/trucks';
import { getDriverAuditProperties, getDriverAuditUsers } from 'src/fetch/drivers';
import { getOwnerAuditProperties, getOwnerAuditUsers } from 'src/fetch/owners';
import { getMileageBandsAuditProperties, getMileageBandsAuditUsers } from 'src/fetch/markets';
import {
  getEquipmentAuditProperties,
  getEquipmentAuditUsers,
  getEquipmentTypeAuditProperties,
  getEquipmentTypeAuditUsers,
} from 'src/fetch/equipmentType';
import { getCustomerLoginAuditProperties, getCustomerLoginAuditUsers } from 'src/fetch/customerLogins';
import { getQuotesAuditProperties, getQuotesAuditUsers, getQuotesNestedEntities, getQuotesNestedEntityName } from 'src/fetch/quotes';
import { getSchedulingTerminalsAuditProperties, getSchedulingTerminalsAuditUsers } from 'src/fetch/schedulingTerminals';
import { getPaymentGoalAuditProperties, getPaymentGoalAuditUsers } from 'src/fetch/marketPaymentGoals';
import { getGwiMoveContactAuditProperties, getGwiMoveContactAuditUsers } from 'src/fetch/gwiMoveContacts';
import { getTerminateReasonAuditProperties, getTerminateReasonAuditUsers } from 'src/fetch/terminateReasons';
import {
  getCostsAuditUsers,
  getCostsAuditProperties,
  getCCCCommodityAuditProperties,
  getCCCCommodityAuditUsers,
  getCCCStandardAuditProperties,
  getCCCStandardAuditUsers,
  getScheduleAuditUsers,
  getScheduleAuditProperties,
  getWarehousesAuditUsers,
  getWarehousesAuditProperties,
  getUnitsOfMeasureAuditProperties,
  getUnitsOfMeasureAuditUsers,
  getBayLocationsAuditProperties,
  getBayLocationsAuditUsers,
  getHandlingStandardAuditsUsers,
  getHandlingStandardAuditsProperties,
  getAdditionalChargeAuditUsers,
  getAdditionalChargeAuditProperties,
} from 'src/fetch/warehouse';
import {
  getCarriersAuditProperties,
  getCarriersAuditUsers,
  getCarrierRatesAuditProperties,
  getCarrierRatesAuditUsers,
  getCarrierTerminalsAuditProperties,
  getCarrierTerminalsAuditUsers,
  getRoleAuditProperties,
  getRoleAuditUsers,
  getNoteTemplatesAuditProperties,
  getNoteTemplatesAuditUsers,
  getRescheduleReasonAuditProperties,
  getRescheduleReasonAuditUsers,
  getDeclineDispatchReasonAuditProperties, getDeclineDispatchReasonAuditUsers,
} from 'src/fetch/admin';
import { getDirectStandardsAuditProperties, getDirectStandardsAuditUsers } from 'src/fetch/pricing';
import {
  getWarehouseInstructionsTemplatesAuditProperties,
  getWarehouseInstructionsTemplatesAuditUsers,
} from 'src/fetch/warehouseInstructions';
import { getDeductionAuditProperties, getDeductionAuditUsers } from 'src/fetch/deductions';
import { getRateZoneAuditProperties, getRateZoneAuditUsers } from 'src/fetch/rateZones';
import {
  getDispatchersAuditUsers,
  getDispatchersProperties,
  getDispatcherGroupAuditProperties,
  getDispatcherGroupAuditUsers,
} from 'src/fetch/dispatching';
import { getDQFFilesAuditUsers, getDQFFilesProperties } from 'src/fetch/files/dqfFiles';
import { getUserAuditProperties, getUserAuditUsers } from 'src/fetch/users';
import { getTruckMakeAuditProperties, getTruckMakeAuditUsers } from 'src/fetch/truckMakes';
import { getOutOfServiceReasonsAuditProperties, getOutOfServiceReasonsAuditUsers } from 'src/fetch/outOfServiceReasons';
import { getPrinterAuditUsers, getPrinterAuditProperties } from 'src/fetch/printers';
import { getlienHoldersAuditProperties, getlienHoldersAuditUsers } from 'src/fetch/lienHolders';
import { getPerDiemCustomContractAuditProperties, getPerDiemCustomContractAuditUsers } from 'src/fetch/perDiem';
import {
  getCorrectiveActionTypeAuditProperties,
  getCorrectiveActionTypeAuditUsers,
  getCorrectiveActionSubjectAuditProperties,
  getCorrectiveActionSubjectAuditUsers,
} from 'src/fetch/correctiveActions';
import {
  getFieldMappingAuditProperties,
  getFieldMappingAuditUsers,
  getFailedMappingAuditProperties,
  getFailedMappingAuditUsers,
} from 'src/fetch/pendingOrders';
import { getRepairOrderAuditProperties, getRepairOrderAuditUsers } from 'src/fetch/repairOrders';
import { getCreditTermsAuditProperties, getCreditTermsAuditUsers } from 'src/fetch/creditTerms';
import { getScheduledReportsAuditProperties, getScheduledReportsAuditUsers } from 'src/fetch/reports';
import { getLaneRateAuditProperties, getLaneRateAuditUsers } from 'src/fetch/laneRates';
import { getRepairIssueAuditProperties, getRepairIssueAuditUsers } from 'src/fetch/repairIssues';
import { getRepairCategoryAuditProperties, getRepairCategoryAuditUsers } from 'src/fetch/repairCategories';
import { getYardUserAuditProperties, getYardUserAuditUsers } from 'src/fetch/yards';
import { getIntegrationUserAuditProperties, getIntegrationUserAuditUsers } from 'src/fetch/integrationUsers';
import { getWeightRuleAuditProperties, getWeightRuleAuditUsers } from 'src/fetch/weightRules';
import { getInsurancePolicyAuditProperties, getInsurancePolicyAuditUsers } from 'src/fetch/risk/insurance';
import { getPermitLocationAuditProperties, getPermitLocationAuditUsers } from 'src/fetch/permitLocations';
import { getMaintReportAuditProperties, getMaintReportAuditUsers } from 'src/fetch/maintReport';
import {
  getInvoiceLineItemsAuditsProperties,
  getInvoiceLineItemsAuditsUsers,
  getInvoiceLineItemTypesAuditsProperties, getInvoiceLineItemTypesAuditsUsers,
} from 'src/fetch/invoices';
import { getPlateTypeAuditProperties, getPlateTypeAuditUsers } from 'src/fetch/plateTypes';
import { getTenantAuditProperties, getTenantAuditUsers } from 'src/fetch/tenant';
import { getRentalCompanyAuditProperties, getRentalCompanyAuditUsers } from 'src/fetch/rentalCompanies';
import { getMessagingV2GroupAuditProperties, getMessagingV2GroupAuditUsers } from 'src/fetch/messaging';
import {
  getSafetyEmailAddressesAuditProperties,
  getSafetyEmailAddressesAuditUsers,
} from 'src/fetch/safetyEmailAddresses';
// consts
import { AUDIT_TYPES } from './consts';
import { getLcDashboardAuditProperties, getLcDashboardAuditUsers } from 'src/fetch/lcDashboard';

const unfilteredTypes = [];

const useFilters = (type, id, variant, nestedEntity) => {
  const [fields, setFields] = useState([]);
  const [users, setUsers] = useState([]);
  const [nestedEntities, setNestedEntities] = useState([]);
  const [nestedEntityNames, setNestedEntityNames] = useState([]);

  const shouldUseFilter = (type) => !unfilteredTypes.includes(type);

  const setupFetchedFilters = ([properties, users, nestedEntities, nestedEntityNames = []]) => {
    setFields(properties);
    setUsers(users);
    setNestedEntities(nestedEntities);
    setNestedEntityNames(nestedEntityNames);
  };

  const loadFilterValues = async () => {
    let result;
    switch (type) {
    case AUDIT_TYPES.DRIVER:
      result = await Promise.all([getDriverAuditProperties(id), getDriverAuditUsers(id)]);
      break;
    case AUDIT_TYPES.LOCATION:
      result = await Promise.all([getLocationAuditProperties(id), getLocationAuditUsers(id)]);
      break;
    case AUDIT_TYPES.ORDER:
      result = await Promise.all([getOrderAuditProperties(id), getOrderAuditUsers(id)]);
      break;
    case AUDIT_TYPES.ORGANIZATION:
      result = await Promise.all([getOrganizationAuditProperties(id), getOrganizationAuditUsers(id)]);
      break;
    case AUDIT_TYPES.ORGANIZATION_ADDITIONAL_CHARGES:
      result = await Promise.all([getOrganizationAdditionalChargesAuditProperties(id), getOrganizationAdditionalChargesAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TRUCK:
      result = await Promise.all([getTruckAuditProperties(id), getTruckAuditUsers(id)]);
      break;
    case AUDIT_TYPES.OWNER:
      result = await Promise.all([getOwnerAuditProperties(id), getOwnerAuditUsers(id)]);
      break;
    case AUDIT_TYPES.EQUIPMENT:
      result = await Promise.all([getEquipmentAuditProperties(id), getEquipmentAuditUsers(id)]);
      break;
    case AUDIT_TYPES.EQUIPMENT_TYPE:
      result = await Promise.all([getEquipmentTypeAuditProperties(id), getEquipmentTypeAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CUSTOMER_LOGINS:
      result = await Promise.all([getCustomerLoginAuditProperties(id), getCustomerLoginAuditUsers(id)]);
      break;
    case AUDIT_TYPES.MARKET:
      result = await Promise.all([getMileageBandsAuditProperties(id), getMileageBandsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.WAREHOUSE_COSTS:
      result = await Promise.all([getCostsAuditProperties(id), getCostsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CCC_COMMODITY:
      result = await Promise.all([getCCCCommodityAuditProperties(id), getCCCCommodityAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CCC_STANDARD:
      result = await Promise.all([getCCCStandardAuditProperties(id), getCCCStandardAuditUsers(id)]);
      break;
    case AUDIT_TYPES.SCHEDULE:
      result = await Promise.all([getScheduleAuditProperties(id), getScheduleAuditUsers(id)]);
      break;
    case AUDIT_TYPES.EXTERNAL_CARRIERS:
      result = await Promise.all([getCarriersAuditProperties(id), getCarriersAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CARRIER_RATES:
      result = await Promise.all([getCarrierRatesAuditProperties(id), getCarrierRatesAuditUsers(id)]);
      break;
    case AUDIT_TYPES.QUOTES:
      result = await Promise.all([
        getQuotesAuditProperties(id),
        getQuotesAuditUsers(id),
        getQuotesNestedEntities(id),
        ...(nestedEntity ? [getQuotesNestedEntityName(id, nestedEntity)] : [])]);
      break;
    case AUDIT_TYPES.SCHEDULING_TERMINAL:
      result = await Promise.all([getSchedulingTerminalsAuditProperties(id), getSchedulingTerminalsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.WAREHOUSE:
      result = await Promise.all([getWarehousesAuditProperties(id), getWarehousesAuditUsers(id)]);
      break;
    case AUDIT_TYPES.DIRECT_STANDARDS:
      result = await Promise.all([getDirectStandardsAuditProperties(id), getDirectStandardsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.UNITS_OF_MEASURE:
      result = await Promise.all([getUnitsOfMeasureAuditProperties(id), getUnitsOfMeasureAuditUsers(id)]);
      break;
    case AUDIT_TYPES.BAY_LOCATIONS:
      result = await Promise.all([getBayLocationsAuditProperties(id), getBayLocationsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.HANDLING_STANDARD:
      result = await Promise.all([getHandlingStandardAuditsProperties(id), getHandlingStandardAuditsUsers(id)]);
      break;
    case AUDIT_TYPES.WAREHOUSE_ADDITIONAL_CHARGE:
      result = await Promise.all([getAdditionalChargeAuditProperties(id), getAdditionalChargeAuditUsers(id)]);
      break;
    case AUDIT_TYPES.WAREHOUSE_INSTRUCTIONS:
      result = await Promise.all([
        getWarehouseInstructionsTemplatesAuditProperties(id),
        getWarehouseInstructionsTemplatesAuditUsers(id),
      ]);
      break;
    case AUDIT_TYPES.DEDUCTIONS:
      result = await Promise.all([getDeductionAuditProperties(id), getDeductionAuditUsers(id)]);
      break;
    case AUDIT_TYPES.PRINTER:
      result = await Promise.all([getPrinterAuditProperties(id), getPrinterAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TERMINAL_PAYMENT_GOALS:
      result = await Promise.all([getPaymentGoalAuditProperties(id), getPaymentGoalAuditUsers(id)]);
      break;
    case AUDIT_TYPES.RATE_ZONES:
      result = await Promise.all([getRateZoneAuditProperties(id), getRateZoneAuditUsers(id)]);
      break;
    case AUDIT_TYPES.USERS:
      result = await Promise.all([getUserAuditProperties(id), getUserAuditUsers(id)]);
      break;
    case AUDIT_TYPES.DISPATCHERS:
      result = await Promise.all([getDispatchersProperties(id), getDispatchersAuditUsers(id)]);
      break;
    case AUDIT_TYPES.DQF_FILES:
      result = await Promise.all([getDQFFilesProperties(id), getDQFFilesAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TRUCK_MAKES:
      result = await Promise.all([getTruckMakeAuditProperties(id), getTruckMakeAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CORRECTIVE_ACTION_SUBJECTS:
      result = await Promise.all([
        getCorrectiveActionSubjectAuditProperties(id),
        getCorrectiveActionSubjectAuditUsers(id),
      ]);
      break;
    case AUDIT_TYPES.CORRECTIVE_ACTION_TYPES:
      result = await Promise.all([getCorrectiveActionTypeAuditProperties(id), getCorrectiveActionTypeAuditUsers(id)]);
      break;
    case AUDIT_TYPES.LIEN_HOLDERS:
      result = await Promise.all([getlienHoldersAuditProperties(id), getlienHoldersAuditUsers(id)]);
      break;
    case AUDIT_TYPES.INTEGRATION_USERS:
      result = await Promise.all([getIntegrationUserAuditProperties(id), getIntegrationUserAuditUsers(id)]);
      break;
    case AUDIT_TYPES.WEIGHT_RULES:
      result = await Promise.all([getWeightRuleAuditProperties(id), getWeightRuleAuditUsers(id)]);
      break;
    case AUDIT_TYPES.REPAIR_ORDERS:
      result = await Promise.all([getRepairOrderAuditProperties(id), getRepairOrderAuditUsers(id)]);
      break;
    case AUDIT_TYPES.PER_DIEM_CUSTOM_CONTRACT_RULES:
      result = await Promise.all([
        getPerDiemCustomContractAuditProperties(id),
        getPerDiemCustomContractAuditUsers(id),
      ]);
      break;
    case AUDIT_TYPES.OUT_OF_SERVICE_REASONS:
      result = await Promise.all([getOutOfServiceReasonsAuditProperties(id), getOutOfServiceReasonsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.ROLES:
      result = await Promise.all([getRoleAuditProperties(id), getRoleAuditUsers(id)]);
      break;
    case AUDIT_TYPES.CREDIT_TERMS:
      result = await Promise.all([getCreditTermsAuditProperties(id), getCreditTermsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.GWI_MOVE_CONTACTS:
      result = await Promise.all([getGwiMoveContactAuditProperties(id), getGwiMoveContactAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TERMINATE_REASONS:
      result = await Promise.all([getTerminateReasonAuditProperties(id), getTerminateReasonAuditUsers(id)]);
      break;
    case AUDIT_TYPES.SCHEDULED_REPORTS:
      result = await Promise.all([getScheduledReportsAuditProperties(id), getScheduledReportsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.LANE_RATES:
      result = await Promise.all([getLaneRateAuditProperties(id), getLaneRateAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TRACE_TERMINAL:
      result = await Promise.all([getCarrierTerminalsAuditProperties(id), getCarrierTerminalsAuditUsers(id)]);
      break;
    case AUDIT_TYPES.REPAIR_ISSUES:
      result = await Promise.all([getRepairIssueAuditProperties(id), getRepairIssueAuditUsers(id)]);
      break;
    case AUDIT_TYPES.REPAIR_CATEGORIES:
      result = await Promise.all([getRepairCategoryAuditProperties(id), getRepairCategoryAuditUsers(id)]);
      break;
    case AUDIT_TYPES.YARD_USERS:
      result = await Promise.all([getYardUserAuditProperties(id), getYardUserAuditUsers(id)]);
      break;
    case AUDIT_TYPES.FIELD_MAPPINGS:
      result = await Promise.all([getFieldMappingAuditProperties(id), getFieldMappingAuditUsers(id)]);
      break;
    case AUDIT_TYPES.NOTE_TEMPLATES:
      result = await Promise.all([getNoteTemplatesAuditProperties(id), getNoteTemplatesAuditUsers(id)]);
      break;
    case AUDIT_TYPES.FAILED_MAPPINGS:
      result = await Promise.all([getFailedMappingAuditProperties(id), getFailedMappingAuditUsers(id)]);
      break;
    case AUDIT_TYPES.INSURANCE_POLICIES:
      result = await Promise.all([getInsurancePolicyAuditProperties(id), getInsurancePolicyAuditUsers(id)]);
      break;
    case AUDIT_TYPES.PERMIT_LOCATIONS:
      result = await Promise.all([getPermitLocationAuditProperties(id), getPermitLocationAuditUsers(id)]);
      break;
    case AUDIT_TYPES.RESCHEDULE_REASONS:
      result = await Promise.all([getRescheduleReasonAuditProperties(id), getRescheduleReasonAuditUsers(id)]);
      break;
    case AUDIT_TYPES.DISPATCH_DECLINE_REASONS:
      result = await Promise.all([getDeclineDispatchReasonAuditProperties(id), getDeclineDispatchReasonAuditUsers(id)]);
      break;
    case AUDIT_TYPES.MAINT_REPORT:
      result = await Promise.all([getMaintReportAuditProperties(id), getMaintReportAuditUsers(id)]);
      break;
    case AUDIT_TYPES.ORGANIZATION_FUEL_TARIFFS:
      result = await Promise.all([getMaintReportAuditProperties(id), getMaintReportAuditUsers(id)]);
      break;
    case AUDIT_TYPES.INVOICE_LINE_ITEMS:
      result = await Promise.all([getInvoiceLineItemsAuditsProperties(id), getInvoiceLineItemsAuditsUsers(id)]);
      break;
    case AUDIT_TYPES.INVOICE_LINE_ITEMS_TYPES:
      result = await Promise.all([getInvoiceLineItemTypesAuditsProperties(id), getInvoiceLineItemTypesAuditsUsers(id)]);
      break;
    case AUDIT_TYPES.PLATE_TYPE:
      result = await Promise.all([getPlateTypeAuditProperties(id), getPlateTypeAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TENANT:
      result = await Promise.all([getTenantAuditProperties(id), getTenantAuditUsers(id)]);
      break;
    case AUDIT_TYPES.DISPATCHER_GROUPS:
      result = await Promise.all([getDispatcherGroupAuditProperties(id), getDispatcherGroupAuditUsers(id)]);
      break;
    case AUDIT_TYPES.RENTAL_COMPANIES:
      result = await Promise.all([getRentalCompanyAuditProperties(id), getRentalCompanyAuditUsers(id)]);
      break;
    case AUDIT_TYPES.TRUCK_PERMIT_RULES:
      result = await Promise.all([getTruckPermitRuleAuditProperties(id), getTruckPermitRuleAuditUsers(id)]);
      break;
    // Messaging entities
    case AUDIT_TYPES.MESSAGING_V2_GROUP:
      result = await Promise.all([getMessagingV2GroupAuditProperties(id), getMessagingV2GroupAuditUsers(id)]);
      break;
    case AUDIT_TYPES.LC_DASHBOARD:
      result = await Promise.all([getLcDashboardAuditProperties(), getLcDashboardAuditUsers()]);
      break;
      case AUDIT_TYPES.SAFETY_EMAIL_ADDRESSES:
      result = await Promise.all([getSafetyEmailAddressesAuditProperties(id), getSafetyEmailAddressesAuditUsers(id)]);
      break;
    default:
      throw new Error(`Unknown audit source ${type}`);
    }

    return result;
  };

  useEffect(() => {
    loadFilterValues().then((result) => {
      if (result) {
        setupFetchedFilters(result);
      }
    });
  }, [nestedEntity]);

  return {
    fields,
    users,
    nestedEntities,
    nestedEntityNames,
    shouldUseFilter,
  };
};

export default useFilters;
